'use strict';

class RcmFatResultsList {
    constructor(fat) {
        this.fat = fat;

        // DOM
        this.list = $('#fatv2-results-list');

        // Selectors
        this.listItemSelector = '.fatv2-results-list-item';
    }

    // Set results (list)
    set() {
        var self = this;

        // Clear list
        self.list.attr('aria-busy', true);
        self.list.html('');

        // show the current "page" of items
        $.each(self.fat.resultsPaged[self.fat.mapCurrentPage].hits, function (index, value) {
            var item = self.getItem(value.item, value.item._rankingInfo.matchedGeoLocation.lat, value.item._rankingInfo.matchedGeoLocation.lng);
            item.appendTo(self.list);
        });

        // Pagination
        self.setPagination();
        self.list.attr('aria-busy', false);
    }

    // Get result item HTML
    getItem(data, lat, lon) {
        var self = this;

        // Distance
        var distance = this.fat._helperTranslateDistance(data._rankingInfo.geoDistance);

        // Item
        var html = `<div class="fatv2-results-list-item ${data.isCertified ? 'is-certified' : ''} ${data.isCertifiedOnline ? 'is-certified-online' : ''}" data-uid="${self.fat._helperGetTeacherUniqueId(data.objectID, lat, lon)}" data-id="${data.objectID}" data-lat="${lat}" data-lon="${lon}">
            <div class="grid-x align-middle">
                <div class="cell shrink">
                    <div class="fatv2-results-list-item-photo ${data.profilePicture ? '' : 'no-photo'}"></div>
                </div>
                <div class="cell auto">
                    <p class="fatv2-results-list-item-tag fatv2-results-list-item-tag-style1"></p>
                    <p class="fatv2-results-list-item-tag fatv2-results-list-item-tag-style2"></p>
                    <p class="h5 fatv2-results-list-item-title">${data.fullName}</p>`
            + (data.teachingLocation && data.teachingLocation.includes('Oscar Peterson School of Music (Toronto)') ? `<div class="fatv2-results-list-item-opstag">Faculty, Oscar Peterson School of Music</div>` : '') +
                    `<p class="fatv2-results-list-item-disciplines"></p>
                    <p class="fatv2-results-list-item-badges"></p>
                </div>
            </div>
            <span class="fatv2-results-list-item-distance">${distance.distance}<span>${distance.unit}</span></span>
        </div>`;

        html = $(html);

        // Photo
        if (data.profilePicture) {
            var imgSrc = `${this.fat._helperGetDrupalBaseUrl()}/${data.profilePicture}`;
            var imgHtml = `<img src="${imgSrc}" alt="${data.fullName}">`;
            html.find('.fatv2-results-list-item-photo').html(imgHtml).css('background-image', `url(${imgSrc})`);
        } else {
            var photoTextHtml = this.fat._helperGetNameInitials(data);
            html.find('.fatv2-results-list-item-photo').html(photoTextHtml);
        }

        // Certified tag
        var elCert = html.find('.fatv2-results-list-item-tag-style1');
        if (!data.isCertified) {
            elCert.remove();
        } else {
            var htmlCert = this._helperGetCertifiedTag(data);
            htmlCert.appendTo(elCert);
        }

        // Online Certified tag
        var elCert = html.find('.fatv2-results-list-item-tag-style2');
        if (!data.isCertifiedOnline) {
            elCert.remove();
        } else {
            var htmlCert = this._helperGetCertifiedOnlineTag(data);
            htmlCert.appendTo(elCert);
        }

        // Disciplines
        var elDisc = html.find('.fatv2-results-list-item-disciplines');
        if (!data.disciplines || data.disciplines.length == 0) {
            elDisc.remove();
        } else {
            $.each(data.disciplines, function (index, value) {
                if (index > 0) {
                    elDisc.append(', ');
                }

                var htmlDisc = self._helperGetDisciplineItem(data, value);
                htmlDisc.appendTo(elDisc);
            });
        }

        // Badges
        var elBadges = html.find('.fatv2-results-list-item-badges');
        if (!data.isCertified && !data.isCertifiedOnline && !data.isExaminer && !data.hasLrct && !data.hasArct) {
            elBadges.remove();
        } else {
            var htmlBadge = '';

            // Badge Certified
            if (data.isCertified) {
                htmlBadge = this._helperGetBadgeItem(data, 'certified', 'Certified Teacher');
                htmlBadge.appendTo(elBadges);
            }

            // Badge Certified Online
            if (data.isCertifiedOnline) {
                htmlBadge = this._helperGetBadgeItem(data, 'certified-online', 'Certified Online Teacher');
                htmlBadge.appendTo(elBadges);
            }

            // Badge Examiner
            if (data.isExaminer) {
                htmlBadge = this._helperGetBadgeItem(data, 'examiner', 'RCM Examiner');
                htmlBadge.appendTo(elBadges);
            }

            // Badge LRCT/ARCT
            if (data.hasLrct) {
                htmlBadge = this._helperGetBadgeItem(data, 'arct-lcrt', 'LRCM');
                htmlBadge.appendTo(elBadges);
            } else if (data.hasArct) {
                htmlBadge = this._helperGetBadgeItem(data, 'arct-lcrt', 'ARCT');
                htmlBadge.appendTo(elBadges);
            }

            // Badge First Class Students
            if (data.numFirstClassHonoursStudents) {
                htmlBadge = this._helperGetBadgeItem(data, 'first-class-students', data.numFirstClassHonoursStudents);
                htmlBadge.appendTo(elBadges);
            }
        }

        return html;
    }

    // Get certified tag
    _helperGetCertifiedTag(data) {
        var html = `<span class="fatv2-results-list-item-tag-inner">RCM CERTIFIED</span>`;
        html = $(html);
        return html;
    }

    // Get certified online tag
    _helperGetCertifiedOnlineTag(data) {
        var html = `<span class="fatv2-results-list-item-tag-inner">CERTIFIED ONLINE TEACHER</span>`;
        html = $(html);
        return html;
    }

    // Get discipline item
    _helperGetDisciplineItem(data, value) {
        var html = `<span class="fatv2-results-list-item-disciplines-inner">${value}</span>`;
        html = $(html);
        return html;
    }

    // Get badge item
    _helperGetBadgeItem(data, helperClass, helperLabel) {
        var html = `<span class="fatv2-results-list-item-badges-inner is-${helperClass}">${helperLabel}</span>`;
        html = $(html);
        return html;
    }

    // Set pagination
    setPagination() {

        var self = this;


        // wrapper
        var paginationWrapper = document.getElementById('fatv2-results-list-pagination');
        paginationWrapper.innerHTML = '';

        var pagerClass = 'fatv2-results-list-pagination pager-navs';

        // first
        var firstBtn = document.createElement('a');
        firstBtn.href = '#';
        firstBtn.className = pagerClass + ' pager-first';
        firstBtn.innerHTML = 'First';
        firstBtn.setAttribute('data-target-page', 0);

        // prev
        var prevBtn = document.createElement('a');
        prevBtn.href = '#';
        prevBtn.className = pagerClass + ' pager-prev';
        prevBtn.innerHTML = 'Previous';
        prevBtn.setAttribute('data-target-page', self.fat.mapCurrentPage - 1);

        // items
        var pagerIndex = self.fat.mapPageGroup[0];
        var pagerItems = document.createElement('div');
        pagerItems.className = 'pager-nav-items';
        while (pagerIndex <= self.fat.mapPageGroup[1] && pagerIndex < self.fat.resultsPaged.length) {

            var _label = pagerIndex + 1;
            var _item;
            if (pagerIndex == self.fat.mapCurrentPage) {
                _item = document.createElement('span');
            }
            else {
                _item = document.createElement('a');
                _item.className = 'pager-navs';
                _item.setAttribute('data-target-page', pagerIndex);
            }
            _item.innerHTML = _label;
            _item.title = `Go to page ${_label}`;
            pagerItems.appendChild(_item);
            pagerIndex++;
        }

        // next
        var nextBtn = document.createElement('a');
        nextBtn.href = '#';
        nextBtn.className = pagerClass + ' pager-next';
        nextBtn.innerHTML = 'Next';
        nextBtn.setAttribute('data-target-page', self.fat.mapCurrentPage + 1);

        // last
        var lastBtn = document.createElement('a');
        lastBtn.href = '#';
        lastBtn.className = pagerClass + ' pager-last';
        lastBtn.innerHTML = 'Last Page';
        lastBtn.setAttribute('data-target-page', self.fat.resultsPaged.length - 1);


        // set prev or next button to disabled
        // depending on the current page
        if (self.fat.mapCurrentPage == 0) {
            // if we're on the first page
            // disable prev button
            prevBtn.ariaDisabled = true;
            prevBtn.classList.add('disabled');
            // and disable the `first page` button
            firstBtn.ariaDisabled = true;
            firstBtn.classList.add('disabled');

        }
        else if ((self.fat.mapCurrentPage + 1) == self.fat.resultsPaged.length) {
            // if we're on the last page
            // disable next button
            nextBtn.ariaDisabled = true;
            nextBtn.classList.add('disabled');
            // and disable the last page button
            lastBtn.ariaDisabled = true;
            lastBtn.classList.add('disabled');
        }

        paginationWrapper.appendChild(firstBtn);
        paginationWrapper.appendChild(prevBtn);
        paginationWrapper.appendChild(pagerItems);
        paginationWrapper.appendChild(nextBtn);
        paginationWrapper.appendChild(lastBtn);

    }

    // Get list item jQuery object
    getItemObj(uniqueId) {
        return $(this.listItemSelector).filter(`[data-uid="${uniqueId}"]`);
    }
}
